import React from 'react';
import {
    BrowserRouter as Router,
    Redirect,
    Route,
    Switch
} from 'react-router-dom';
import RequiredPublicAuth from "./common/middleware/authPublicPermission";

import Login from "./containers/auth/Login/Login";
import ChangePassword from "./containers/auth/Login/ChangePassword";
import Forbidden from "./containers/Errors/Forbidden";

import Layout from "./containers/Layout/Layout";
import jwt from 'jsonwebtoken';

// import './assets/css/bootstrap.css';
import './assets/css/styles.css';
import './assets/css/_width.scss';
import './assets/css/_background.scss';
import './assets/css/_custom-styles.scss';
import './assets/css/_sidemenu.scss';
import './assets/css/_header.scss';
import './assets/css/_dropdown.scss';
import './assets/css/icons.scss';
import './assets/css/custom.css';
import 'react-image-lightbox/style.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import './assets/css/base.scss';
import './assets/css/_button.scss';

const PrivateRoute = ({ component: Component, ...rest }) => {
    const accessToken = localStorage.getItem('accessToken');
    const publicKey = process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_PUBLIC_KEY`];

    let isAuthenticated = false;

    if (accessToken) {
        try {
            jwt.verify(accessToken, publicKey, { algorithms: ['RS256'] });
            isAuthenticated = true;
        } catch (error) {
            isAuthenticated = false;
        }
    }

    return (
        <Route
            {...rest}
            render={(props) =>
                isAuthenticated ? (
                    <Component {...props} />
                ) : (
                    <Redirect to="/login" />
                )
            }
        />
    );
};

function App() {
    
    return (
        <Router>
            <Switch>
                <Route exact path="/login" name="Login" component={RequiredPublicAuth(Login)}/>
                <Route exact path="/change_password" name="Change Password" component={RequiredPublicAuth(ChangePassword)}/>
                <Route exact path="/forbidden" name="Forbidden" component={Forbidden} />
                <PrivateRoute path="/" name="Home" component={Layout} />
                <Redirect from="/" to="/login"/>
            </Switch>
        </Router>
    );
}

export default App;
